import React from 'react';

export function InputObligatorio(props) {
	return (
		<>
			<b style={{ color: 'red' }}>*</b>
		</>
	);
}
